import { compose, lifecycle, withProps } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import withLoading from '../../../../../common/withLoading';
import withNewDesignStyles from '../../../../../common/hoc/withNewDesignStyles';
import {
  getReportData,
  getReportDefinitionById,
  isFiltersDirty,
  isReportDataFetched,
} from '../../selectors';
import {
  fetchReportDefinition,
} from '../../actions';
import CustomReport from './CustomReport';

export default compose(
  withNewDesignStyles,
  withRouter,
  connect(
    (state, ownProps) => ({
      reportDefinition: getReportDefinitionById(state, ownProps.params.id),
      isDirty: isFiltersDirty(state),
      reportData: getReportData(state),
      isReportDataFetched: isReportDataFetched(state),
    }),
    {
      fetchReportDefinition,
    }
  ),
  withProps(props => ({
    showLoading: !props.reportDefinition,
  })),
  lifecycle({
    componentWillMount() {
      if (!this.props.reportDefinition) {
        this.props.fetchReportDefinition(this.props.params.id);
      }
    },
  }),
  withLoading,
)(CustomReport);
